import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "product-tag__circle" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "product-tag__name details-bold" }
const _hoisted_5 = { class: "product-tag__price" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "product-tag__price-arrow",
  src: "/icons/right-arrow.svg"
}, null, -1)

import {
  ref, computed, watch, inject,
  nextTick,
} from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTag',
  props: {
  positionX: {
    type: Number,
    required: true,
  },
  positionY: {
    type: Number,
    required: true,
  },
  variant: {
    type: Object,
    required: true,
  },
  isImageLoadedAndVisible: {
    type: Boolean,
    default: true,
  },
  isExpanded: {
    type: Boolean,
    default: false,
  },
  showInstantly: {
    type: Boolean,
    default: false,
  },
},
  emits: ['expand-tag', 'product-click'],
  setup(__props, { emit }) {

const props = __props



const { formatPrice } = useContext();
const { websiteText } = useWebsiteTexts();

// eslint-disable-next-line max-len
const price = computed(() => props.variant.priceAndCampaign?.campaignPrice || props.variant.priceAndCampaign?.unitPrice);

const formattedPrice = computed(() => {
  if (!price.value) return null;

  return formatPrice(price.value);
});

// eslint-disable-next-line no-undef


const rootElement = ref<any>(null);
const labelElement = ref<any>(null);

const delayHasPassed = ref(props.showInstantly);

const coordinatesStyling = computed(() => ({
  left: `${props.positionX}%`,
  top: `${props.positionY}%`,
}));

const classes = computed(() => {
  const result = [
    props.positionY < 50 ? 'product-tag--north' : 'product-tag--south',
  ];

  if (labelElement.value) {
    const wrapperBounds = rootElement.value.parentElement.getBoundingClientRect();
    const labelBounds = labelElement.value.getBoundingClientRect();
    const labelWidthPerc = (labelBounds.width / wrapperBounds.width) * 100;

    if (props.positionX - labelWidthPerc < 0) {
      result.push('product-tag--west');
    }
    if (props.positionX + labelWidthPerc > 100) {
      result.push('product-tag--east');
    }
  }

  if (props.isExpanded) {
    result.push('product-tag--expanded');
  }

  if (props.showInstantly || (props.isImageLoadedAndVisible && delayHasPassed.value)) {
    result.push('product-tag--loaded');
  }

  if (!props.showInstantly) {
    result.push('product-tag--animated');
  }

  if (props.positionY < 0
      || props.positionY > 100
      || props.positionX < 0
      || props.positionX > 100) {
    result.push('product-tag--hidden');
  }
  return result;
});

const isVisible = computed(() => props.positionX >= 0
        && props.positionX <= 100
        && props.positionY >= 0
        && props.positionY <= 100);

watch(() => props.isImageLoadedAndVisible, () => {
  setTimeout(() => {
    delayHasPassed.value = true;
  }, props.positionY * 5);
},
{ immediate: true });

watch(() => props.isExpanded, (newVal) => {
  if (newVal) {
    nextTick(() => {
      labelElement.value.focus();
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(isVisible) && props.variant?.url)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "rootElement",
        ref: rootElement,
        class: _normalizeClass(["product-tag", _unref(classes)])
      }, [
        _createElementVNode("button", {
          class: "clean-button product-tag__toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('expand-tag'))),
          style: _normalizeStyle(_unref(coordinatesStyling)),
          "aria-label": _unref(websiteText)('product_tag__view_product_information').value
        }, _hoisted_3, 12, _hoisted_1),
        (__props.isExpanded)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "clean-button product-tag__label",
              ref_key: "labelElement",
              ref: labelElement,
              style: _normalizeStyle(_unref(coordinatesStyling)),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('product-click')))
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(props.variant.name), 1),
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(formattedPrice)) + " ", 1),
                _hoisted_6
              ])
            ], 4))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})